import { render } from "./IELand.vue?vue&type=template&id=d099f9f4"
import script from "./IELand.vue?vue&type=script&lang=js"
export * from "./IELand.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Repos\\c2stem\\c2stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__